import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_EXPORT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import AnalyticsFoodCostWithGroupsExportModal from '../../components/AnalyticsFoodCostWithGroupsExportModal';

export const getAnalyticsFoodCostByCategoryExportByStoreModalConfig = (
  data,
  handleExport,
  handleCloseCleanUp,
) => ({
  type: 'action',
  width: '512px',
  height: '512px', // in order to display the whole calendar
  icon: '/images/inpulse/file-download-black-small.svg',
  title: i18next.t('ORDERS.BY_CATEGORY.EXPORT_FOOD_COST_BY_CATEGORY_TITLE'),
  component: AnalyticsFoodCostWithGroupsExportModal,
  data,
  handleCloseCleanUp,
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_EXPORT_BUTTON(),
      handleClick: handleExport,
    },
  ],
});
